import React, { PropsWithChildren } from 'react';

interface TableHeadingProps {
  className?: string;
  colSpan?: number;
  rowSpan?: number;
  style?: any;
}

function TableHeading({
  children,
  className,
  colSpan,
  rowSpan,
  style,
}: PropsWithChildren<TableHeadingProps>) {
  return (
    <th colSpan={colSpan} rowSpan={rowSpan} className={className} style={style}>
      {children}
    </th>
  );
}

export default TableHeading;
